import { sagaCreator } from '@adrias-online/steiner';

import helper from 'helpers/steinerHelper';
import { actions, actionTypes } from '../actions/interessiMarketing';
import { selectors, DEFAULT_STATE } from '../reducers/interessiMarketing';
import api from '../apis/interessiMarketing';

const sagas = helper.createSagas('interessiMarketing', actionTypes, actions, api, selectors, DEFAULT_STATE);

const defaultSagas = sagaCreator.bootSagas(sagas, actionTypes);

export default [
    ...defaultSagas
];